import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import blogImg from "../../assets/img/avoConsulteBlogImg.png";
import {
  articleExcerpt,
  articleUrl,
  formatArticleDate,
} from "./articleHelpers";
import "./magazine.css";
import { currentLang } from "../../shared/seo/links";

// Article preview used by the magazine page and the home page.
export default function ArticleCard({ blog, className }) {
  const Lng = currentLang();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const url = articleUrl(blog, Lng);

  function open(e) {
    e.preventDefault();
    navigate(url);
  }

  return (
    <div className={className}>
      <article className="avc-post-card">
        <a href={url} onClick={open} className="avc-post-card__media" tabIndex={-1}>
          <img
            src={blog.image || blogImg}
            onError={(e) => {
              e.target.src = blogImg;
            }}
            alt=""
            width="1200"
            height="675"
            loading="lazy"
            decoding="async"
          />
        </a>
        <div className="avc-post-card__body">
          <div className="avc-post-card__meta">
            {blog.category && <span className="avc-tag">{blog.category}</span>}
            <time dateTime={blog.createdAt}>
              {formatArticleDate(blog.createdAt, Lng)}
            </time>
          </div>
          <h3 className="avc-post-card__title">
            <a href={url} onClick={open}>
              {blog.title || t("blog_is_not_available")}
            </a>
          </h3>
          <p className="avc-post-card__excerpt">{articleExcerpt(blog)}</p>
          <a href={url} onClick={open} className="avc-post-card__more" tabIndex={-1}>
            {t("read_article")}
            <i
              className={Lng === "ar" ? "fas fa-arrow-left" : "fas fa-arrow-right"}
              aria-hidden="true"
            ></i>
          </a>
        </div>
      </article>
    </div>
  );
}
